import axios from 'axios'
import { get } from 'lodash/fp'
import { put, call, select } from 'redux-saga/effects'

import { PUT_EXTRAS } from './extras.actions'
import {
  POINTS_SET_SELECTED_POINT_START,
  POINTS_SET_SELECTED_POINT_FINALLY,
} from '../Points/points.actions'

export default {
  * getExtras({ payload }) {
    try {
      yield put(POINTS_SET_SELECTED_POINT_START())
      const { data: extrasData } = yield select(get('Extras'))

      if (!extrasData[payload.value]) {
        const { data: extras } = yield call(axios.get, 'api/extras', {
          params: {
            q: {
              source: payload.source,
              source_id: payload.value,
              valid: true,
              visible: true,
            },
          },
        })

        yield put(PUT_EXTRAS({ [payload.value]: extras }))
      }
    } catch (error) {
      console.log({ error })
    } finally {
      yield put(POINTS_SET_SELECTED_POINT_FINALLY())
    }
  },
}
